import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isSurveyAllowed } from '../services/survey/is-survey-allowed';
import { TripService } from '../services/trip.service';

export const surveyGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  return isSurveyAllowed(trip, tripService.hasEnded())
    ? true
    : router.createUrlTree(['/dashboard']);
};
